export const TROUBLESHOOTING_WIKI =
    "https://w.amazon.com/bin/view/ALIGHT/CDB/UsingCDB/Troubleshooting/";

export const CONTENT_OWNER_TROUBLESHOOTING_WIKI =
    "https://w.amazon.com/bin/view/ALIGHT/CDB/UsingCDB/Troubleshooting#HContentOwners";

export const WORKBENCH_SIM_TICKET =
    "https://t.corp.amazon.com/create/templates/4977f75f-0898-427c-a041-5e78fa14bcd8"; //TO BE UPDATED WHEN SIM TEMPLATE IS CREATED

export const SALESFORCE_ACCOUNT_ACCESS_URL =
    "https://w.amazon.com/bin/view/InsightsHub/TrainingResources#HShort-TermAccessSOP";
